export const createMpShowPageEventParams = (data) => ({
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName,
    'Is Pro': data.isPro,
    'Source Component': data.sourceComponent,
    'Gig Card Position': data.pos,
    'Context Page Number': data.contextPageNumber,
    'Number of Packages': data.packagesCount
});

export const createMpComparePackagesParams = (data) => ({
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName
});

export const createMpPackageSelectParams = (data) => ({
    'Package Position': data.source,
    'Package Selected': data.id
});

export const createMpTopNavClickParams = (data) => ({
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName,
    'Displayed Sections': data.displayedSections,
    'Clicked Section': data.clickedSection
});

export const createMpSellerAnchorClickParams = (data) => ({
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName
});

export const createMpClickedTab = (data) => ({
    'Tab Name': data['Tab Name'],
    'Category Name': data.categoryName,
    'Sub Category Name': data.subCategoryName,
    'Category Id': data.categoryId,
    'Sub Category Id': data.subCategoryId,
    'Nested Sub Category Id': data.nestedSubCategoryId,
    'Is pro': data.isPro
});

export const createMpBreadcrumbsClickParams = (data) => ({
    'Category Id': data.categoryId,
    'Sub Category Id': data.subCategoryId,
    'Nested Sub Category Id': data.nestedSubCategoryId,
    'Is pro': data.isPro
});
